import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import Switch from '@material-ui/core/Switch';
import MarkdownIt from 'markdown-it';
import MdEditor from 'react-markdown-editor-lite';
// import style manually for MdEditor
import 'react-markdown-editor-lite/lib/index.css';

import CustomDropzoneComponent from '../shared/CustomDropzoneComponent';
import { getAdminBrands, getAdminProduct, getResourceFile, updateAdminProduct, uploadResourceFile } from '../../network';
import TagsComponent from '../shared/TagsComponent';
import CurrencyInputComponent from '../shared/CurrencyInputComponent';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';

const Container = styled.div`
	//height: -webkit-fill-available;
	height: calc(100vh - 4.5rem); // desperation
	flex-grow: 1;
`;

const PageHeader = styled.h1`
	height: 1.25rem;
	font-size: 1.25rem;
	line-height: 1.25rem;

	font-family: OpticianSans, serif;
	font-style: normal;
	font-weight: normal;

	color: var(--color-gray-500);
`;

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	width: 100%;
	height: -webkit-fill-available;

	margin: 1rem 0 1rem 0;
	padding: 0;

	background: white;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
	border-radius: 0.25rem;

	overflow-y: scroll;
`;

const ActionsBar = styled.div`
	display: flex;
	align-items: center;
	margin-top: auto;
	padding: var(--space-24);
	border-top: 1px solid var(--color-gray-300);
	> button {
		border: none;
		box-shadow: none;
		background: none;
		padding: var(--space-6) var(--space-8);
		border-radius: var(--space-4);
		color: var(--company-dark);
		font-size: var(--font-16);
		font-weight: normal;
		&:nth-of-type(2) {
			margin-left: var(--space-24);
			color: var(--color-gray-700);
		}
		&:hover {
			background-color: var(--color-gray-200);
			transition: background-color 0.3s ease-in;
		}
		&:last-of-type {
			margin-left: auto;
			color: var(--color-red-700);
		}
	}
`;

const TabsRow = styled.div`
	display: flex;
	flex-direction: row;
`;

const Tab = styled.div`
	display: flex;
	flex-direction: row;

	align-items: center;
	justify-content: center;

	height: var(--space-56);

	padding: 0 var(--space-24);

	background: ${(props) =>
        props.selected ? 'white' : 'var(--color-gray-100)'};
	border-bottom: ${(props) =>
        props.selected ? 'none' : '1px solid var(--color-gray-300)'};
	border-right: 1px solid var(--color-gray-300);

	cursor: pointer;

	> span {
		font-weight: normal;
		font-style: normal;
		font-size: var(--font-16);
		line-height: var(--font-16);

		color: ${(props) =>
        props.selected ? 'var(--color-gray-900)' : 'var(--color-gray-700)'};
	}

	> img {
		margin-left: var(--space-12);
	}
`;

const InnerEditContainer = styled.div`
	display: grid;
	grid-template-columns: auto 21rem;
	grid-gap: var(--space-40);

	padding: var(--space-56);
`;

const Column = styled.div`
	display: flex;
	flex-direction: column;

	width: 100%;
`;

const FieldTitle = styled.span`
	font-weight: 500;
	font-size: var(--font-14);
	line-height: var(--font-14);
	margin-left: var(--space-16);

	color: var(--color-gray-500);
`;

const ProductSummaryRow = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	column-gap: var(--space-32);
	row-gap: var(--space-8);
`;

const ProductSummaryColumn = styled.div`
	display: grid;
	grid-template-rows: auto auto;
	row-gap: var(--space-8);
`;

const InputField = styled.input`
	width: 100%;
	height: var(--space-40);

	padding: var(--space-12) var(--space-16);

	background: white;
	border: 1px solid var(--color-gray-400);
	box-sizing: border-box;
	border-radius: var(--space-4);

	font-weight: normal;
	font-style: normal;
	font-size: var(--space-16);
	line-height: var(--space-16);

	color: var(--color-gray-900);
	
	&:disabled {
	  color: var(--color-gray-500);
	  background: var(--color-gray-200);
	}
`;

const Dropdown = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	width: 100%;
	height: var(--space-40);

	border: 1px solid var(--color-gray-400);
	box-sizing: border-box;
	border-radius: var(--space-4);

	padding: var(--space-12) var(--space-16);

	> select {
	    width: 100%;
		//height: 1.5rem;
		background: transparent;
		border: 0;

		appearance: none;
		outline: none;

		font-weight: normal;

		font-style: normal;
		font-size: var(--space-16);
		line-height: var(--space-16);

		color: var(--color-gray-900);
	}
	
	> img {
        margin-left: var(--space-16);
    }
`;

const ProductButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;

	width: fit-content;
	height: var(--space-20);

	font-weight: normal;
	font-style: normal;
	font-size: var(--font-12);
	line-height: var(--font-12);

	padding: var(--space-4) var(--space-6);

	color: white;

	border: none;
	background: var(--color-orange-600);
	box-shadow: 0 4px 6px rgba(221, 107, 32, 0.12),
		0 2px 4px rgba(221, 107, 32, 0.08);
	border-radius: var(--space-4);
	transition: background-color 0.3s ease-in;

	cursor: pointer;

	&:hover {
		background: var(--color-orange-500);
	}
`;

const DropzoneContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	height: 6rem;

	margin-bottom: var(--space-16);

	background: var(--color-gray-100);
	border: 1px dashed var(--color-gray-300);
	box-sizing: border-box;
	border-radius: var(--space-8);
`;

const InfoText = styled.span`
	font-style: normal;
	font-weight: normal;
	font-size: var(--font-14);
	line-height: var(--font-18);

	color: var(--color-gray-500);
`;

const MarkdownContainer = styled.div`
	height: 18rem;

	padding: var(--space-16);
	background: var(--color-gray-100);

	border: 1px solid var(--color-gray-300);
	box-sizing: border-box;
	border-radius: var(--space-4);

	// for MdEditor
	> div {
		height: 100%;

		> div > div > div {
			> .button.button-type-quote,
			.button.button-type-hr,
			.button.button-type-inlinecode,
			.button.button-type-code,
			.button.button-type-table,
			.button.button-type-image,
			.button.button-type-link {
				display: none;
			}
		}
	}
`;

const PlainContainer = styled.div`
	display: flex;
	flex-direction: column;

	padding: var(--space-24) var(--space-16);
	background: var(--color-gray-100);

	border-radius: var(--space-4);
`;

const AliasInputContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	margin-bottom: var(--space-16);

	> input {
		width: -webkit-fill-available;
		height: 1.875rem;

		padding: var(--space-8) var(--space-10);

		background: white;
		border: 1px solid var(--color-gray-400);
		box-sizing: border-box;
		border-radius: var(--space-4);

		font-weight: normal;
		font-style: normal;
		font-size: var(--space-14);
		line-height: var(--space-14);

		color: var(--color-gray-900);
	}

	> img {
		margin-left: var(--space-16);
		cursor: pointer;
	}
`;

const AddAliasButton = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

    width: fit-content;
    
	margin-top: var(--space-8);

	cursor: pointer;

	> span {
		font-weight: normal;
		font-style: normal;
		font-size: var(--font-16);
		line-height: var(--font-16);
		color: var(--company-dark);
	}

	> img {
		margin-left: var(--space-4);
	}
`;

const MediaContainer = styled.div`
	display: grid;
	grid-template-columns: auto auto auto auto;
	grid-gap: var(--space-24);
`;

const ProductImageContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;

	width: 8.75rem;
	height: 8.75rem;

	background: white;

	/* margin-bottom: var(--space-40); */

	/* border: 1px solid var(--color-gray-300);
	box-sizing: border-box;
	border-radius: var(--space-8); */

	> .close {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;

		width: var(--space-24);
		height: var(--space-24);

		font-size: var(--font-12);
		line-height: var(--font-12);
		color: var(--color-gray-700);

		background: var(--color-gray-100);
		border: 1px solid var(--color-gray-600);
		box-sizing: border-box;

		border-radius: var(--space-20);
		left: 8rem;
		bottom: 8rem;

		cursor: pointer;
	}

	> div.image-container {
	    display: flex;
        align-items: center;
        justify-content: center;
    
		width: 100%;
		height: 100%;

		overflow: hidden;

		border: 1px solid var(--color-gray-300);
		box-sizing: border-box;
		border-radius: var(--space-8);

		> img {
			width: 100%;
			object-fit: cover;
		}

		> video {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
`;

const OptionTitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	
	margin-right: var(--space-16);

	> span {
		font-style: normal;
		font-weight: normal;
		font-size: var(--font-16);
		line-height: var(--font-16);

		color: var(--color-gray-900);
	}

	> img {
		margin-left: auto;
		cursor: pointer;

		&:last-of-type {
			margin-left: var(--space-14);
		}
	}
`;

const OptionInputContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

    margin-right: var(--space-16);
    margin-left: var(--space-16);
	margin-bottom: var(--space-16);

	> input {
		width: -webkit-fill-available;
		height: 1.875rem;

		padding: var(--space-8) var(--space-10);

		background: white;
		border: 1px solid var(--color-gray-400);
		box-sizing: border-box;
		border-radius: var(--space-4);

		font-weight: normal;
		font-style: normal;
		font-size: var(--space-14);
		line-height: var(--space-14);

		color: var(--color-gray-900);
	}

	> button {
        border: none;
        box-shadow: none;
        background: none;
        padding: 0;
        //padding: var(--space-6) var(--space-8);
        //border-radius: var(--space-4);
        font-size: var(--font-16);
        font-weight: normal;
        
		margin-left: var(--space-16);
        color: var(--color-red-700);
		
		//&:hover {
        //  background-color: var(--color-gray-200);
        //  transition: background-color 0.3s ease-in;
        //}
	}
`;

const AddOptionButton = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	margin-top: var(--space-8);
	margin-right: var(--space-16);
	margin-left: var(--space-16);

	cursor: pointer;

	> span {
		font-weight: normal;
		font-style: normal;
		font-size: var(--font-16);
		line-height: var(--font-16);
		color: var(--company-dark);
	}

	> img {
		margin-left: var(--space-4);
	}
`;

const PricingInputRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;

	margin-bottom: var(--space-12);

    > span {
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-14);
        line-height: var(--font-14);
        
        margin-right: auto;
        
        color: var(--color-gray-700);
    }

	> input {
		//width: -webkit-fill-available;
		height: 1.875rem;

		padding: var(--space-8) var(--space-10);

		background: white;
		border: 1px solid var(--color-gray-400);
		box-sizing: border-box;
		border-radius: var(--space-4);

		font-weight: normal;
		font-style: normal;
		font-size: var(--space-14);
		line-height: var(--space-14);

		color: var(--color-gray-900);
	}

	> img {
		margin-left: var(--space-20);
		cursor: pointer;
	}
	
	> div.dropdown {
	    display: flex;
        align-items: center;
        justify-content: space-between;
    
        //width: 100%;
        height: 1.875rem;
    
        border: 1px solid var(--color-gray-400);
        box-sizing: border-box;
        border-radius: var(--space-4);
    
        padding: var(--space-8) var(--space-10);
    
        > select {
            //height: 1.5rem;
            background: transparent;
            border: 0;
    
            appearance: none;
            outline: none;
    
            font-weight: normal;
    
            font-style: normal;
            font-size: var(--space-14);
            line-height: var(--space-14);
    
            color: var(--color-gray-900);
        }
        
        > img {
            margin-left: var(--space-16);
        }
	}
`;

const ProductOptionsGridRow = styled.div`
  display: grid;
  grid-template-columns: 10rem auto;
  grid-gap: var(--space-16);
`;

const InventoryOptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  
  align-items: center;
  
  height: var(--space-56);
  
  > span {
    margin-right: var(--space-64);
    
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    color: var(--color-gray-600);
    
    cursor: pointer;
  }
  
  > div {
    display: flex;
    flex-direction: row;
  }
`;

const InventoryOption = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  
  height: var(--space-56);
  
  padding: 0 var(--space-20);
  border-radius: var(--space-4);
  
  font-style: normal;
  font-weight: ${props => props.selected ? '600' : '500'};
  font-size: var(--font-16);
  line-height: var(--font-16);
  
  color: ${props => props.selected ? 'white' : props.attribute ? 'var(--color-teal-600)' : 'var(--color-purple-600)'};
  background: ${props => props.selected && props.attribute ? 'var(--color-teal-600)' : props.selected && props.size ? 'var(--color-purple-600)' : 'white'};
  
  cursor: pointer;
`;

const InventoryTableRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 25% 25% 25% 25%;
  
  align-items: center;
  
  border-radius: var(--space-4);
  background: ${props => props.selected ? 'var(--color-gray-100)' : ''};
  
  height: var(--space-48);
`;

const InventoryTableInputRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto auto auto;
  grid-gap: var(--space-32);
  
  align-items: center;
  
  height: var(--space-48);
  
  > span {
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    cursor: pointer;
    
    &:first-of-type {
      color: var(--color-green-600)
    }
    
    &:last-of-type {
      color: var(--color-red-700);
    }
  }
`;

const InventoryTableHeader = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: var(--font-12);
  line-height: var(--font-12);
  
  padding: 0 var(--space-16);
  
  color: var(--color-gray-400);
  
  cursor: pointer;
`;

const InventoryTableCell = styled.span`
  font-style: normal;
  font-weight: ${props => props.attribute || props.size ? '500' : 'normal'};
  font-size: var(--font-16);
  line-height: var(--font-16);
  
  padding: 0 var(--space-16);
  
  color: ${props => props.attribute ? 'var(--color-teal-600)' : props.size ? 'var(--color-purple-600)' : 'var(--color-gray-800)'};
`;

const CurrencyInputField = props => <InputField {...props} />;

const CurrencyCustomFormat = ({ inputRef, onChange, ...props }) => {
    return (
        <NumberFormat
            {...props}
            getInputRef={inputRef}
            onValueChange={values => onChange(values.value)}
            customInput={CurrencyInputField}
            thousandSeparator
            isNumericString
            fixedDecimalScale
            decimalScale={2}
            prefix="$"
        />
    );
};

function ProductEditComponent({ auth, details: productDetails, setDetailsEdit, saveProductEntry, deleteProductEntry }) {
    const fileInputRef = useRef();
    const descriptionMdRef = useRef();
    const featuresMdRef = useRef();

    const [togglePrice, setTogglePrice] = useState(false);
    const [details, setDetails] = useState(productDetails ? productDetails : {
        product: {
            aliases: [],
            tags: [],
            variants: [],
            media: [],
            price: 1,
            min_stock: 1
        }
    });
    const [product, setProduct] = useState(null);
    const [tabIndex, setTabIndex] = useState(0);
    const [attributes, setAttributes] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [permutations, setPermutations] = useState([]);
    const [exceptions, setExceptions] = useState([]); // pricing exceptions

    const [exclusions, setExclusions] = useState([]);
    const [editAttribute, enableEditAttribute] = useState(false);
    const [editSize, enableEditSize] = useState(false);

    const [brands, setBrands] = useState([]);

    const [tags, setTags] = useState(productDetails && productDetails.product && productDetails.product.tags ? productDetails.product.tags.map(tag => ({
        id: tag.toLowerCase(),
        text: tag
    })) : []);

    const tabs = [
        {
            title: 'Product Summary',
            icon: 'summary',
        },
        {
            title: 'Product Tags',
            icon: 'tags',
        },
        {
            title: 'Product Media',
            icon: 'media',
        },
        {
            title: 'Product Options',
            icon: 'options',
        },
        {
            title: 'Product Inventory',
            icon: 'inventory'
        }
        // {
        //     title: 'Product Pricing',
        //     icon: 'pricing',
        // },
    ];

    const mdEditorViewOptions = {
        menu: true,
        md: true,
        html: false,
        fullScreen: false,
        hideMenu: false,
    };
    const mdParser = new MarkdownIt();

    const adminToken = auth ? auth.token : null;

    useEffect(() => {
        getAdminBrands(adminToken)
            .then((result) => setBrands([...result]))
            .catch(error => console.error(error));

        if (details.product_id) {
            getAdminProduct(adminToken, details.product_id)
                .then(result => {
                    setProduct(result);
                    // setTogglePrice(result.price_toggle);
                    if (!result) return;
                    const productAttributes = result.variants.map(variant => variant.attribute);
                    const productSizes = result.variants.map(variant => variant.size);

                    const _attributes = [...new Set(productAttributes)];
                    const _sizes = [...new Set(productSizes)];

                    // populating attributes array
                    setAttributes([..._attributes]);

                    // populating sizes array
                    setSizes([..._sizes]);
                    setTogglePrice(result.price_toggle);
                })
                .catch(error => console.error(error));
        }
    }, []);

    useEffect(() => {
        generateVariantPermutations();
        console.log('just to see', product)
    }, [attributes, sizes]);

    useEffect(() => {
        if (descriptionMdRef.current) handleProductChange('description_html', descriptionMdRef.current.getHtmlValue());
    }, [details.product.description]);

    useEffect(() => {
        if (featuresMdRef.current) handleProductChange('features_html', featuresMdRef.current.getHtmlValue());
    }, [details.product.features]);

    useEffect(() => {
        const productTags = tags.map(tag => tag.text);
        handleProductChange('tags', productTags);
    }, [tags]);

    const openFileDialog = () => {
        if (!fileInputRef.current) return;
        fileInputRef.current.click();
    };

    const handleFileChange = e => {
        const file = e.target.files[0];
        if (file) fileUpload(file);
    };



    const onDrop = files => {
        const file = files[0];
        if (file) fileUpload(file);
    };

    const fileUpload = file => {
        uploadResourceFile(adminToken, file)
            .then(result => {
                const type = result.mimetype.includes('image') ? 'image' : result.mimetype.includes('video') ? 'video' : null;
                if (type) {
                    const mediaObject = {
                        type,
                        resource: result.id
                    };
                    const media = [...details.product.media, mediaObject];
                    handleProductChange('media', media);
                }
            })
            .catch(error => console.error(error));
    };

    const handleEditorChange = (name, { html, text }) => {
        console.log('handleEditorChange', html, text);

        handleProductChange(name, text);

        // if (descriptionMdRef.current) console.log(descriptionMdRef.current.getHtmlValue());
        // if (descriptionMdRef.current) console.log(descriptionMdRef.current.getMdValue());
    };

    const handleProductChange = (key, value) => {
        let { product } = details;
        product = {
            ...product,
            [key]: value
        };

        setDetails({
            ...details,
            product
        });
    };

    const handleToggle = () => {
        setTogglePrice(!togglePrice);
        handleProductChange('price_toggle', !togglePrice);
    }

    const handleVariantChange = (key, value) => {

    };

    const generateVariantPermutations = () => {
        const permutations = [];
        const _exceptions = [];

        attributes.forEach(attribute => {
            sizes.forEach(size => {
                if (attribute && size) {
                    permutations.push({
                        attribute,
                        size,
                        price: product ? product.price : 0,
                        value: `${attribute}:${size}`,
                        variant_id: null
                    });
                }
            });
        });

        if (product && product.variants) {
            permutations.map(permutation => {
                product.variants.forEach(variant => {
                    if (permutation.attribute === variant.attribute && permutation.size === variant.size) {
                        permutation.price = variant.price;
                        permutation.variant_id = variant._id;
                        permutation.stock = variant.stock;
                        permutation.max_stock = variant.max_stock;
                    }
                });
            });
        }

        // loading permutations from variants pulled from database
        permutations.map(permutation => {
            if (permutation.variant_id) _exceptions.push({
                ...permutation,
                value: `${permutation.attribute}:${permutation.size}`
            });
        });

        let newExceptions = [...exceptions, ..._exceptions];
        newExceptions = newExceptions.filter((exception, index, self) => index === self.findIndex(e => e.value === exception.value && e.price !== product?.price));

        setPermutations(permutations);
        setExceptions(newExceptions);
    };

    const showSection = (index) => {
        switch (index) {
            case 0: {
                // Summary
                return (
                    <>
                        <Column>
                            <ProductSummaryRow
                                style={{ marginBottom: 'var(--space-40)' }}
                            >
                                <FieldTitle>Product Name</FieldTitle>
                                <FieldTitle>Product Brand</FieldTitle>
                                <InputField disabled={details.product_id} name="name" value={details.product.name} type="text" onChange={e => {
                                    const { name, value } = e.target;
                                    handleProductChange(name, value);
                                }} />
                                <Dropdown>
                                    <select name="brand_id" value={details.product && details.product.brand_id ? details.product.brand_id : ''} onChange={e => {
                                        const { name, value } = e.target;
                                        handleProductChange(name, value);
                                    }}>
                                        <option value="" disabled>
                                            Select Brand
                                        </option>
                                        {brands.map((brand) => (
                                            <option
                                                key={brand._id}
                                                value={brand._id}
                                            >
                                                {brand.name}
                                            </option>
                                        ))}
                                    </select>
                                    <img
                                        alt="dropdown"
                                        src="/icons/chevron.svg"
                                    />
                                </Dropdown>
                            </ProductSummaryRow>
                            <ProductSummaryColumn
                                style={{ marginBottom: 'var(--space-24)' }}
                            >
                                <FieldTitle>Product Description</FieldTitle>
                                <MarkdownContainer>
                                    <MdEditor
                                        ref={descriptionMdRef}
                                        value={details.product.description}
                                        renderHTML={(text) => mdParser.render(text)}
                                        onChange={options => handleEditorChange('description', { ...options })}
                                        config={{
                                            view: mdEditorViewOptions,
                                            canView: mdEditorViewOptions,
                                        }}
                                    />
                                </MarkdownContainer>
                            </ProductSummaryColumn>

                            <ProductSummaryColumn>
                                <FieldTitle>Product Features</FieldTitle>
                                <MarkdownContainer>
                                    <MdEditor
                                        ref={featuresMdRef}
                                        value={details.product.features}
                                        renderHTML={(text) => mdParser.render(text)}
                                        onChange={options => handleEditorChange('features', { ...options })}
                                        config={{
                                            view: mdEditorViewOptions,
                                            canView: mdEditorViewOptions,
                                        }}
                                    />
                                </MarkdownContainer>
                            </ProductSummaryColumn>
                        </Column>
                        <Column>
                            <PlainContainer>
                                <FieldTitle
                                    style={{
                                        marginLeft: '0',
                                        marginBottom: 'var(--space-24)',
                                    }}
                                >
                                    Product Aliases
                                </FieldTitle>
                                {
                                    (details.product && details.product.aliases.length !== 0) ? <>
                                        {
                                            details.product.aliases.map((alias, index) => {
                                                return <AliasInputContainer key={`AliasInputContainer_${index}`}>
                                                    <input type="text" value={alias} onChange={e => {
                                                        const { value } = e.target;

                                                        let aliases = [...details.product.aliases];
                                                        aliases[index] = value;
                                                        handleProductChange('aliases', aliases);
                                                    }} />
                                                    <img src="/icons/trash.svg" onClick={() => {
                                                        let aliases = [...details.product.aliases];
                                                        aliases.splice(index, 1);
                                                        handleProductChange('aliases', aliases);
                                                    }} />
                                                </AliasInputContainer>;
                                            })
                                        }
                                    </> : null
                                }
                                <AddAliasButton onClick={() => {
                                    if (details.product && details.product.aliases) {
                                        let aliases = [...details.product.aliases];
                                        aliases.push('');
                                        handleProductChange('aliases', aliases);
                                    } else handleProductChange('aliases', ['']);
                                }}>
                                    <span>Add Product Alias</span>
                                    <img src="/icons/add_circle.svg" />
                                </AddAliasButton>
                            </PlainContainer>
                        </Column>
                    </>
                );
            }
            case 1: {
                // Tags
                return (
                    <>
                        <Column>
                            <TagsComponent tags={tags} setTags={setTags} />
                        </Column>
                        <Column>
                            <InputField
                                type="text"
                                placeholder="Search tags..."
                            />
                        </Column>
                    </>
                );
            }
            case 2: {
                // Media
                return (
                    <>
                        <Column>
                            <MediaContainer>
                                {
                                    (details.product && details.product.media.length !== 0) ? <>
                                        {
                                            details.product.media.map((media, index) => {
                                                return <ProductImageContainer key={`ProductImageContainer_${index}`}>
                                                    <div className="image-container">
                                                        {media.type === 'image' ? <img src={getResourceFile(media.resource)} /> : null}
                                                        {media.type === 'video' ? <video
                                                            src={getResourceFile(media.resource)}
                                                            controls
                                                        /> : null}
                                                    </div>
                                                    <div className="close" onClick={() => {
                                                        let media = [...details.product.media];
                                                        media.splice(index, 1);
                                                        handleProductChange('media', media);
                                                    }}>
                                                        <img src="/icons/close_dark.svg" />
                                                    </div>
                                                </ProductImageContainer>;
                                            })
                                        }
                                    </> : null
                                }
                            </MediaContainer>
                        </Column>
                        <Column>
                            <ProductButton
                                style={{ marginBottom: 'var(--space-16)' }}
                                onClick={openFileDialog}
                            >
                                Upload a Media File
                            </ProductButton>
                            <div style={{ display: 'none' }}>
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="image/*,video/*"
                                    onChange={handleFileChange}
                                />
                            </div>
                            <DropzoneContainer>
                                <CustomDropzoneComponent
                                    text="or drag & drop file to Upload"
                                    upload={handleFileChange}
                                    onDrop={onDrop}
                                />
                            </DropzoneContainer>
                            <InfoText>
                                Max 2MB file size. Supported file types include
                                png, jpeg, jpg, mp4, avi, vlc and wav.
                            </InfoText>
                        </Column>
                    </>
                );
            }
            case 3: {
                // Options
                return (
                    <>
                        <Column>
                            <PlainContainer
                                style={{
                                    width: '60%',
                                    marginBottom: 'var(--space-48)',
                                }}
                            >
                                <OptionTitleContainer style={{ marginBottom: 'var(--space-24)' }}>
                                    {
                                        !editAttribute
                                            ? <span>{details.product.attribute_name ? details.product.attribute_name : 'Attribute'}</span>
                                            : <InputField
                                                name="attribute_name"
                                                style={{ width: '60%' }}
                                                type="text"
                                                value={details.product.attribute_name || ''}
                                                onChange={e => {
                                                    const { name, value } = e.target;
                                                    handleProductChange(name, value);
                                                }}
                                            />
                                    }
                                    <img onClick={() => enableEditAttribute(!editAttribute)} src="/icons/edit_stroke.svg" />
                                    <img src="/icons/trash_red.svg" onClick={() => handleProductChange('attribute_name', 'Attribute')} />
                                </OptionTitleContainer>
                                {
                                    (attributes.length !== 0) ? <>
                                        {
                                            attributes.map((attribute, index) => {
                                                return (attribute/*.attribute*/ || attribute/*.attribute*/ === '') ?
                                                    <OptionInputContainer key={`OptionInputContainerAttribute_${index}`}>
                                                        <input type="text" value={attribute/*.attribute*/} onChange={e => {
                                                            const { value } = e.target;
                                                            const newArray = [...attributes];
                                                            newArray[index]/*.attribute*/ = value;

                                                            setAttributes([...newArray]);
                                                        }} />
                                                        <button onClick={() => {
                                                            const newArray = [...attributes];
                                                            newArray.splice(index, 1);

                                                            setAttributes([...newArray]);
                                                        }}>
                                                            Delete
                                                        </button>
                                                    </OptionInputContainer> : null;
                                            })
                                        }
                                    </> : null
                                }
                                <AddOptionButton onClick={() => {
                                    // setAttributes([...attributes, {
                                    //     variant_id: null,
                                    //     attribute: ''
                                    // }]);

                                    setAttributes([...attributes, '']);
                                }}>
                                    <span>Add Attribute Option</span>
                                    <img src="/icons/add_circle.svg" />
                                </AddOptionButton>
                            </PlainContainer>

                            <PlainContainer style={{ width: '60%' }}>
                                <OptionTitleContainer style={{ marginBottom: 'var(--space-24)' }}>
                                    {
                                        !editSize
                                            ? <span>{details.product.size_name ? details.product.size_name : 'Size'}</span>
                                            : <InputField
                                                name="size_name"
                                                style={{ width: '60%' }}
                                                type="text"
                                                value={details.product.size_name || ''}
                                                onChange={e => {
                                                    const { name, value } = e.target;
                                                    handleProductChange(name, value);
                                                }}
                                            />
                                    }
                                    <img onClick={() => enableEditSize(!editSize)} src="/icons/edit_stroke.svg" />
                                    <img src="/icons/trash_red.svg" onClick={() => handleProductChange('size_name', 'Size')} />
                                </OptionTitleContainer>
                                {
                                    (sizes.length !== 0) ? <>
                                        {
                                            sizes.map((size, index) => {
                                                return (size/*.size*/ || size/*.size*/ === '') ? <OptionInputContainer key={`OptionInputContainerSize_${index}`}>
                                                    <input type="text" value={size/*.size*/} onChange={e => {
                                                        const { value } = e.target;
                                                        const newArray = [...sizes];
                                                        newArray[index]/*.size*/ = value;

                                                        setSizes([...newArray]);
                                                    }} />
                                                    <button onClick={() => {
                                                        const newArray = [...sizes];
                                                        newArray.splice(index, 1);

                                                        setSizes([...newArray]);
                                                    }}>
                                                        Delete
                                                    </button>
                                                </OptionInputContainer> : null;
                                            })
                                        }
                                    </> : null
                                }
                                <AddOptionButton onClick={() => {
                                    // setSizes([...sizes, {
                                    //     variant_id: null,
                                    //     size: ''
                                    // }]);

                                    setSizes([...sizes, '']);
                                }}>
                                    <span>Add Size Option</span>
                                    <img src="/icons/add_circle.svg" />
                                </AddOptionButton>
                            </PlainContainer>

                            {/*<ProductButton style={{marginTop: 'var(--space-56)'}}>*/}
                            {/*    Create New Option Configuration*/}
                            {/*</ProductButton>*/}
                        </Column>
                        <Column>
                            <FieldTitle>Min Stock Alert (units)</FieldTitle>
                            <InputField name="min_stock" style={{ marginTop: 'var(--space-8)' }} value={details.product.min_stock} onChange={e => {
                                const { name, value } = e.target;
                                handleProductChange(name, value);
                            }} />



                            <FieldTitle style={{ marginTop: 'var(--space-56)' }}>Default Price</FieldTitle>
                            <CurrencyCustomFormat style={{ marginTop: 'var(--space-8)' }} value={details.product.price} onChange={value => {
                                console.log(value);
                                handleProductChange('price', value);
                            }} />



                            {
                                product.price_toggle ? (
                                    <>
                                        <FieldTitle style={{ marginTop: 'var(--space-56)' }}>Pricing Exceptions</FieldTitle>
                                        {
                                            exceptions.map((exception, index) => {
                                                return <ProductOptionsGridRow
                                                    key={`PricingExceptionRow_${index}`}
                                                    style={{
                                                        marginTop: 'var(--space-8)',
                                                        marginBottom: 'var(--space-8)'
                                                    }}>
                                                    <Dropdown>
                                                        <select
                                                            value={exception.value}
                                                            onChange={e => {
                                                                const { value } = e.target;

                                                                if (value === 'remove') {
                                                                    const newArray = [...exceptions];
                                                                    newArray.splice(index, 1);

                                                                    setExceptions([...newArray]);
                                                                } else {
                                                                    const attribute = value.split(':')[0];
                                                                    const size = value.split(':')[1];

                                                                    const newArray = [...exceptions];
                                                                    exceptions[index].attribute = attribute;
                                                                    exceptions[index].size = size;
                                                                    exceptions[index].value = value;

                                                                    for (let i = 0; i < permutations.length; i++) {
                                                                        if (permutations[i].value === value && permutations[i].variant_id) {
                                                                            exceptions[index].variant_id = permutations[i].variant_id;
                                                                            exceptions[index].stock = permutations[i].stock;
                                                                            exceptions[index].max_stock = permutations[i].max_stock;
                                                                            break;
                                                                        }
                                                                    }

                                                                    setExceptions([...newArray]);
                                                                }
                                                            }}>
                                                            <option value="" disabled>Select Product</option>
                                                            <option value="remove">-Remove-</option>
                                                            {
                                                                permutations.map((permutation, index) => {
                                                                    return <option
                                                                        key={`PermutationOption_${index}`}
                                                                        value={`${permutation.attribute}:${permutation.size}`}>
                                                                        {permutation.attribute}, {permutation.size}
                                                                    </option>;
                                                                })
                                                            }
                                                        </select>
                                                        <img
                                                            alt="dropdown"
                                                            src="/icons/chevron.svg"
                                                        />
                                                    </Dropdown>

                                                    <CurrencyCustomFormat
                                                        value={exception.price}
                                                        onChange={value => {
                                                            const newArray = [...exceptions];
                                                            exceptions[index].price = value;

                                                            setExceptions([...newArray]);
                                                        }} />
                                                </ProductOptionsGridRow>;
                                            })
                                        }

                                        <AddOptionButton style={{
                                            marginTop: 'var(--space-16)',
                                            marginLeft: 'var(--space-16)'
                                        }} onClick={() => {
                                            setExceptions([...exceptions, {
                                                attribute: null,
                                                size: null,
                                                variant_id: null,
                                                price: product ? product.price : 0,
                                                value: ''
                                            }]);
                                        }}>
                                            <span>Add Pricing Exception</span>
                                            <img src="/icons/add_circle.svg" />
                                        </AddOptionButton>

                                    </>
                                ) : null
                            }
                            <div style={{display: 'flex', alignItems: 'baseline'}}>
                            OFF
                            <Switch
                                checked={togglePrice}
                                onChange={handleToggle}
                                color="primary"
                                name="toggle"
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                            ON
                            </div>
                        </Column>
                    </>
                );
            }
            case 4: {
                // Inventory
                return (
                    <>
                        <Column style={{
                            gridColumnStart: '1',
                            gridColumnEnd: '3'
                        }}>
                            <InventoryOptionsRow>
                                <span>Clear Filters</span>
                                <div>
                                    {
                                        attributes.map((attribute, index) => <InventoryOption key={`InventoryOptionAttribute_${index}`} attribute>{attribute}</InventoryOption>)
                                    }
                                    {
                                        sizes.map((size, index) => <InventoryOption key={`InventoryOptionSize_${index}`} size>{size}</InventoryOption>)
                                    }
                                </div>
                            </InventoryOptionsRow>
                        </Column>
                        <Column>
                            <InventoryTableRow>
                                <InventoryTableHeader>Attribute</InventoryTableHeader>
                                <InventoryTableHeader>Size</InventoryTableHeader>
                                <InventoryTableHeader>Min Stock Alert</InventoryTableHeader>
                                <InventoryTableHeader>Inventory</InventoryTableHeader>
                            </InventoryTableRow>
                            {
                                permutations.map((permutation, index) => {
                                    return <InventoryTableRow key={`InventoryTableRowPermutation_${index}`}>
                                        <InventoryTableCell attribute>{permutation.attribute}</InventoryTableCell>
                                        <InventoryTableCell size>{permutation.size}</InventoryTableCell>
                                        <InventoryTableCell>{permutation.max_stock} unit{`${permutation.max_stock !== 1 ? 's' : ''}`}</InventoryTableCell>
                                        <InventoryTableCell>{permutation.stock}</InventoryTableCell>
                                    </InventoryTableRow>;
                                })
                            }
                        </Column>
                        <Column>
                            <InventoryTableRow style={{ gridTemplateColumns: 'auto' }}>
                                <InventoryTableHeader>Adjust Stock</InventoryTableHeader>
                            </InventoryTableRow>
                            {
                                permutations.map((permutation, index) => {
                                    return <InventoryTableInputRow key={`InventoryTableInputRow_${index}`}>
                                        <InputField style={{ height: '1.875rem' }} type="number" value={permutation.stock} onChange={e => {
                                            const { value } = e.target;
                                            const newArray = [...permutations];
                                            newArray[index].stock = value < 0 ? 0 : value;

                                            setPermutations([...newArray]);
                                        }} />
                                        <span onClick={() => {
                                            const newArray = [...permutations];
                                            newArray[index].stock = newArray[index].stock + 1;

                                            setPermutations([...newArray]);
                                        }}>Add</span>
                                        <span onClick={() => {
                                            const newArray = [...permutations];
                                            newArray[index].stock = newArray[index].stock - 1;
                                            newArray[index].stock = newArray[index].stock < 0 ? 0 : newArray[index].stock;

                                            setPermutations([...newArray]);
                                        }}>Remove</span>
                                    </InventoryTableInputRow>;
                                })
                            }
                        </Column>

                        {/*<Column style={{width: '60%'}}>
                            <div style={{marginBottom: 'var(--space-32)'}}>
                                <PricingInputRow>
                                    <span>Item Sale:</span>
                                    <div className="dropdown">
                                        <select value="0" onChange={e => console.log(e.target.value)}>
                                            {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100].map(discount => (
                                                <option
                                                    key={`ProductPricingSaleOptionDiscount_${discount}`}
                                                    value={discount}
                                                >
                                                    {`${discount}%`}
                                                </option>
                                            ))}
                                        </select>
                                        <img alt="dropdown" src="/icons/chevron.svg"/>
                                    </div>
                                </PricingInputRow>

                                <PricingInputRow>
                                    <span>Duration:</span>
                                    <div className="dropdown">
                                        <select value="0" onChange={e => console.log(e.target.value)}>
                                            {[1, 3, 5, 7, 14, 21, 28].map(duration => (
                                                <option
                                                    key={`ProductPricingSaleOptionDuration_${duration}`}
                                                    value={duration}
                                                >
                                                    {`${duration} day${duration !== 1 ? 's' : ''}`}
                                                </option>
                                            ))}
                                        </select>
                                        <img alt="dropdown" src="/icons/chevron.svg"/>
                                    </div>
                                </PricingInputRow>
                            </div>

                            <div style={{marginBottom: 'var(--space-32)'}}>
                                <PricingInputRow>
                                    <span>14G, 11cm:</span>
                                    <input type="text"/>
                                    <img src="/icons/close_dark.svg"/>
                                </PricingInputRow>
                                <PricingInputRow>
                                    <span>14G, 12cm:</span>
                                    <input type="text"/>
                                    <img src="/icons/close_dark.svg"/>
                                </PricingInputRow>
                                <PricingInputRow>
                                    <span>14G, 14cm:</span>
                                    <input type="text"/>
                                    <img src="/icons/close_dark.svg"/>
                                </PricingInputRow>
                            </div>
                            <div>
                                <PricingInputRow>
                                    <span>18G, 11cm:</span>
                                    <input type="text"/>
                                    <img src="/icons/close_dark.svg"/>
                                </PricingInputRow>
                                <PricingInputRow>
                                    <span>18G, 12cm:</span>
                                    <input type="text"/>
                                    <img src="/icons/close_dark.svg"/>
                                </PricingInputRow>
                            </div>
                        </Column>
                        <Column>
                            <ProductButton>
                                Add Pricing Permutation
                            </ProductButton>
                        </Column>*/}
                    </>
                );
            }
            default:
                return null;
        }
    };

    return (
        <Container>
            <PageHeader>{(details.product && details.product.name) ? `EDIT PRODUCT - ${details.product.name /*details.order_number*/}` : 'ADD PRODUCT'}</PageHeader>
            <ContentContainer>
                <TabsRow>
                    {tabs.map((tab, index) => (
                        <Tab
                            key={`ProductEditTab_${index}`}
                            selected={index === tabIndex}
                            onClick={() => setTabIndex(index)}
                        >
                            <span>{tab.title}</span>
                            <img src={`/icons/tab_${tab.icon}.svg`} />
                        </Tab>
                    ))}
                </TabsRow>
                <InnerEditContainer>{showSection(tabIndex)}</InnerEditContainer>
                <ActionsBar>
                    <button onClick={() => saveProductEntry(details, permutations, exceptions)}>Save Changes</button>
                    <button onClick={() => setDetailsEdit(null)}>Cancel</button>
                    {(details.product && details.product.name) && <button onClick={() => deleteProductEntry(details)}>Delete Entry</button>}
                </ActionsBar>
            </ContentContainer>
        </Container>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user
});

export default connect(mapStateToProps, null)(ProductEditComponent);

